import * as env from "lib/environment"
import { FeatureFlagReadModel } from "featureFlags/domain/flag"
import { BrowserStorageFactory } from "featureFlags/infrastructure/browserStorage"
import {
  CombinedSourcesFeatureFlagReadModel,
  EnvVarFeatureFlagReadModel
} from "featureFlags/infrastructure/flagSources"

export class FeatureFlagReadModelFactory {
  build = (): FeatureFlagReadModel => {
    if (env.ENABLE_NEW_FEATURE_FLAGGING) {
      return new CombinedSourcesFeatureFlagReadModel(
        new BrowserStorageFactory().build(),
        env
      )
    } else {
      return new EnvVarFeatureFlagReadModel(env)
    }
  }
}
